import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  DateGrouping,
  ChartType,
  type ChartClickEventArgs,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';
import { useMemo, useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.LineChart.LineChartYoYDemo';

// Year-over-year: month on the x-axis, year as the series. Each year
// becomes one line so you can compare seasonal shape across years.
// Mirrors the Blazor demo's GroupBy: Month, SeriesDateGrouping: Year
// configuration verbatim.
export function LineChartYoYSample() {
  const t = useT();
  const [lastClick, setLastClick] = useState<ChartClickEventArgs | null>(null);
  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'actualclosedate',
        groupByDateGrouping: DateGrouping.MonthOfYear,
        seriesDateGrouping: DateGrouping.Year,
        aggregateColumn: 'estimatedvalue',
        aggregate: QueryAggregate.Sum,
        filterXml:
          "<filter><condition attribute='statecode' operator='ne' value='0' /></filter>",
      }),
    [],
  );
  return (
    <>
      <DataverseChart
        dataSource={source}
        type={ChartType.Line}
        title={t(`${STRINGS_BASE}.chart-title`)}
        yAxisPrefix="$"
        onElementClick={setLastClick}
      />
      {lastClick && (
        <p style={{ marginTop: '12px' }}>
          <strong>{t(`${STRINGS_BASE}.clicked-label`)}:</strong>{' '}
          {lastClick.datasetLabel} — {lastClick.label} — ${lastClick.value.toLocaleString()}
        </p>
      )}
    </>
  );
}
